// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1osq{width:100%}
._1e0c11p5{display:grid}
._1p57pxbi{row-gap:var(--ds-space-200,1pc)}
._p12ffkat{max-width:386px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/assets-modal/search-container/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,+BAA+B;AAC1C,WAAW,eAAe","sourcesContent":["._1bsb1osq{width:100%}\n._1e0c11p5{display:grid}\n._1p57pxbi{row-gap:var(--ds-space-200,1pc)}\n._p12ffkat{max-width:386px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
